"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importColumnDescriptions = exports.importRateTitleEventHints = exports.importColumnLegacyLabels = exports.importColumnLabels = void 0;
const locales_1 = require("../enums/locales");
exports.importColumnLabels = {
    [locales_1.Locales.EN]: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        secondaryEmail: "Secondary email",
        language: "Language",
        address: "Address",
        city: "City",
        region: "Region",
        postalCode: "Postal code",
        country: "Country",
        phone: "Phone",
        lists: "Lists",
        note: "Contact note",
        companyName: "Company name",
        householdName: "Household name",
        subscriptionStatus: "Subscription status",
        amount: "Amount",
        eligibleAmount: "Receipt eligible amount",
        paymentMethod: "Payment Method",
        formTitle: "Fundraising campaign",
        rateTitle: "Rate title",
        fund: "Fund",
        date: "Date",
        expirationDate: "Expiration date",
        receiptUrl: "Receipt URL",
        receiptNumber: "Receipt number",
        ticketUrl: "Ticket URL",
        annotation: "Payment annotation",
    },
    [locales_1.Locales.FR]: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Courriel",
        secondaryEmail: "Courriel secondaire",
        language: "Langue",
        address: "Adresse",
        city: "Ville",
        region: "Région",
        postalCode: "Code postal",
        country: "Pays",
        phone: "Téléphone",
        lists: "Listes",
        note: "Note du contact",
        companyName: "Nom de l'entreprise",
        householdName: "Nom de la famille",
        subscriptionStatus: "Statut d'abonnement",
        amount: "Montant",
        eligibleAmount: "Montant admissible au reçu",
        paymentMethod: "Méthode de paiement",
        formTitle: "Campagne de collecte",
        rateTitle: "Titre du tarif",
        fund: "Fonds",
        date: "Date",
        expirationDate: "Date d'expiration",
        receiptUrl: "URL du reçu",
        receiptNumber: "Numéro de reçu",
        ticketUrl: "URL du billet",
        annotation: "Annotation du paiement",
    },
    [locales_1.Locales.ES]: {
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Email",
        secondaryEmail: "Email secundario",
        language: "Idioma",
        address: "Dirección",
        city: "Ciudad",
        region: "Región",
        postalCode: "Código postal",
        country: "País",
        phone: "Teléfono",
        lists: "Listas",
        note: "Nota del contacto",
        companyName: "Nombre de la empresa",
        householdName: "Nombre de la familia",
        subscriptionStatus: "Estado de suscripción",
        amount: "Monto",
        eligibleAmount: "Monto elegible para el recibo",
        paymentMethod: "Método de pago",
        formTitle: "Campaña de recaudación",
        rateTitle: "Título de la tarifa",
        fund: "Fondo",
        date: "Fecha",
        expirationDate: "Fecha de expiración",
        receiptUrl: "URL del recibo",
        receiptNumber: "Número de recibo",
        ticketUrl: "URL del boleto",
        annotation: "Anotación del pago",
    },
    [locales_1.Locales.DE]: {
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        secondaryEmail: "Zweite E-Mail-Adresse",
        language: "Sprache",
        address: "Adresse",
        city: "Stadt",
        region: "Bundesland",
        postalCode: "Postleitzahl",
        country: "Land",
        phone: "Telefon",
        lists: "Listen",
        note: "Kontaktnotiz",
        companyName: "Firmenname",
        householdName: "Haushaltsname",
        subscriptionStatus: "Abonnementstatus",
        amount: "Betrag",
        eligibleAmount: "Belegfähiger Betrag",
        paymentMethod: "Zahlungsmethode",
        formTitle: "Spendenkampagne",
        rateTitle: "Tariftitel",
        fund: "Fonds",
        date: "Datum",
        expirationDate: "Ablaufdatum",
        receiptUrl: "Beleg-URL",
        receiptNumber: "Belegnummer",
        ticketUrl: "Ticket-URL",
        annotation: "Zahlungsanmerkung",
    },
};
// The wording these columns carried before they were renamed. Flatfile matches an incoming header against a
// field's alternative names as well as its label, so a template downloaded before the rename still maps onto
// the sheet instead of arriving as an unmapped column. Read through getImportColumnAlternativeNames.
exports.importColumnLegacyLabels = {
    [locales_1.Locales.EN]: {
        eligibleAmount: "Eligible amount",
        formTitle: "Form Title",
        note: "Note",
        annotation: "Annotation",
    },
    [locales_1.Locales.FR]: {
        eligibleAmount: "Montant admissible",
        formTitle: "Titre du formulaire",
        note: "Note",
        annotation: "Annotation",
    },
    [locales_1.Locales.ES]: {
        eligibleAmount: "Monto elegible",
        formTitle: "Título del formulario",
        note: "Nota",
        annotation: "Anotación",
    },
    [locales_1.Locales.DE]: {
        eligibleAmount: "Abzugsfähiger Betrag",
        formTitle: "Formulartitel",
        note: "Notiz",
        annotation: "Anmerkung",
        region: "Region",
    },
};
// Qualifies the rate column on a payment sheet, where a rate is the ticket type of an event. Read through
// getImportColumnLabel, which leaves the membership label bare: a membership sheet has one rate per tier.
exports.importRateTitleEventHints = {
    [locales_1.Locales.EN]: "for events",
    [locales_1.Locales.FR]: "pour les événements",
    [locales_1.Locales.ES]: "para eventos",
    [locales_1.Locales.DE]: "für Veranstaltungen",
};
exports.importColumnDescriptions = {
    [locales_1.Locales.EN]: {
        firstName: "Contact's first name, only letters, hyphens, apostrophes, and spaces are allowed",
        lastName: "Contact's last name, only letters, hyphens, apostrophes, and spaces are allowed",
        email: "Contact's email address (primary identifier)",
        secondaryEmail: "Contact's secondary email address",
        language: "Contact's preferred language (EN or FR)",
        address: "Contact's street address",
        city: "Contact's city",
        region: "Contact's state/province/region",
        postalCode: "Contact's postal/zip code",
        country: "Two-letter code (e.g., CA, US, FR)",
        phone: "Contact's phone number",
        lists: "Lists to add the contact to (separate multiple with ',' or ';' without spaces)",
        note: "Additional information about the contact",
        companyName: "Contact's company name",
        householdName: "Household the contact belongs to (created if it does not exist yet)",
        subscriptionStatus: "Enter 'unsubscribed' to mark contact as unsubscribed.",
        amount: "Payment amount",
        eligibleAmount: "Part of the amount eligible for a tax receipt",
        paymentMethod: "Payment method",
        formTitle: "Fundraising campaign the payment belongs to",
        rateTitle: "Rate title",
        fund: "Fund the payment is allocated to (matched to your existing funds by name or code)",
        date: "Payment date",
        expirationDate: "Membership expiration date (optional, for membership/abonnement types)",
        receiptUrl: "URL to the receipt file",
        receiptNumber: "Receipt number",
        ticketUrl: "URL to the e-ticket",
        annotation: "Additional notes on the payment",
    },
    [locales_1.Locales.FR]: {
        firstName: "Prénom du contact, seuls les lettres, traits d'union, apostrophes et espaces sont autorisés",
        lastName: "Nom du contact, seuls les lettres, traits d'union, apostrophes et espaces sont autorisés",
        email: "Adresse courriel du contact (identifiant principal)",
        secondaryEmail: "Adresse courriel secondaire du contact",
        language: "Langue préférée du contact (EN ou FR)",
        address: "Adresse du contact",
        city: "Ville du contact",
        region: "État, province ou région du contact",
        postalCode: "Code postal du contact",
        country: "Code à deux lettres (ex. : CA, US, FR)",
        phone: "Numéro de téléphone du contact",
        note: "Informations supplémentaires sur le contact",
        lists: "Listes auxquelles ajouter le contact (séparez-les par ',' ou ';' sans espace)",
        companyName: "Nom de l'entreprise du contact",
        householdName: "Famille à laquelle appartient le contact (créée si elle n'existe pas encore)",
        subscriptionStatus: "Inscrivez 'unsubscribed' pour marquer le contact comme désabonné.",
        amount: "Montant du paiement",
        eligibleAmount: "Partie du montant admissible à un reçu fiscal",
        paymentMethod: "Méthode de paiement",
        formTitle: "Campagne de collecte à laquelle le paiement appartient",
        rateTitle: "Titre du tarif",
        fund: "Fonds auquel le paiement est affecté (associé à vos fonds existants par nom ou par code)",
        date: "Date du paiement",
        expirationDate: "Date d'expiration de l'adhésion (facultatif, pour les types membership ou abonnement)",
        receiptUrl: "URL du fichier du reçu",
        receiptNumber: "Numéro du reçu",
        ticketUrl: "URL du billet électronique",
        annotation: "Notes supplémentaires sur le paiement",
    },
    [locales_1.Locales.ES]: {
        firstName: "Nombre del contacto, solo se permiten letras, guiones, apóstrofos y espacios",
        lastName: "Apellido del contacto, solo se permiten letras, guiones, apóstrofos y espacios",
        email: "Dirección de email del contacto (identificador principal)",
        secondaryEmail: "Dirección de email secundaria del contacto",
        language: "Idioma preferido del contacto (EN o FR)",
        address: "Dirección del contacto",
        city: "Ciudad del contacto",
        region: "Estado, provincia o región del contacto",
        postalCode: "Código postal del contacto",
        country: "Código de dos letras (ej.: CA, US, FR)",
        phone: "Número de teléfono del contacto",
        lists: "Listas a las que agregar el contacto (sepárelas con ',' o ';' sin espacios)",
        note: "Información adicional sobre el contacto",
        companyName: "Nombre de la empresa del contacto",
        householdName: "Familia a la que pertenece el contacto (se crea si aún no existe)",
        subscriptionStatus: "Escriba 'unsubscribed' para marcar el contacto como dado de baja.",
        amount: "Monto del pago",
        eligibleAmount: "Parte del monto elegible para un recibo fiscal",
        paymentMethod: "Método de pago",
        formTitle: "Campaña de recaudación a la que pertenece el pago",
        rateTitle: "Título de la tarifa",
        fund: "Fondo al que se asigna el pago (asociado a sus fondos existentes por nombre o código)",
        date: "Fecha del pago",
        expirationDate: "Fecha de expiración de la membresía (opcional, para los tipos membership o abonnement)",
        receiptUrl: "URL del archivo del recibo",
        receiptNumber: "Número del recibo",
        ticketUrl: "URL del boleto electrónico",
        annotation: "Notas adicionales sobre el pago",
    },
    [locales_1.Locales.DE]: {
        firstName: "Vorname des Kontakts, nur Buchstaben, Bindestriche, Apostrophe und Leerzeichen sind erlaubt",
        lastName: "Nachname des Kontakts, nur Buchstaben, Bindestriche, Apostrophe und Leerzeichen sind erlaubt",
        email: "E-Mail-Adresse des Kontakts (Hauptkennung)",
        secondaryEmail: "Zweite E-Mail-Adresse des Kontakts",
        language: "Bevorzugte Sprache des Kontakts (EN oder FR)",
        address: "Straße und Hausnummer des Kontakts",
        city: "Stadt des Kontakts",
        region: "Bundesland, Provinz oder Region des Kontakts",
        postalCode: "Postleitzahl des Kontakts",
        country: "Zweibuchstabiger Code (z. B. CA, US, FR)",
        phone: "Telefonnummer des Kontakts",
        lists: "Listen, denen der Kontakt hinzugefügt wird (mehrere mit ',' oder ';' ohne Leerzeichen trennen)",
        note: "Zusätzliche Informationen zum Kontakt",
        companyName: "Firmenname des Kontakts",
        householdName: "Haushalt, zu dem der Kontakt gehört (wird angelegt, falls er noch nicht existiert)",
        subscriptionStatus: "Geben Sie 'unsubscribed' ein, um den Kontakt als abgemeldet zu markieren.",
        amount: "Zahlungsbetrag",
        eligibleAmount: "Teil des Betrags, der belegfähig ist",
        paymentMethod: "Zahlungsmethode",
        formTitle: "Spendenkampagne, zu der die Zahlung gehört",
        rateTitle: "Tariftitel",
        fund: "Fonds, dem die Zahlung zugeordnet wird (über Name oder Code Ihren bestehenden Fonds zugeordnet)",
        date: "Zahlungsdatum",
        expirationDate: "Ablaufdatum der Mitgliedschaft (optional, für die Typen membership oder abonnement)",
        receiptUrl: "URL der Belegdatei",
        receiptNumber: "Belegnummer",
        ticketUrl: "URL des E-Tickets",
        annotation: "Zusätzliche Notizen zur Zahlung",
    },
};
